import { AxiosPromise } from 'axios';
export enum RequestTypes
{
    None,
    Create,
    Update,
    Delete,
    Search,
}

export enum CarrierTypeEnum
{
    None,
    USPS,
    UPS ,
    FEDEX,
    DHL
}

export enum PaymentStatusEnum
{
    NotStarted,
    Cancelled,
    RequiresAttention,
    Pending,
    Processing,
    Failed,
    Paid
}

export enum UserRequestType
{
    None = 0,
    UserLogin = 1,
    UserRegistration = 2,
    UserView = 3,
    UserDeviceRegistration = 4,
    GuestSession = 5
}

export enum TokenType
{
    None = 0,
    AccessToken = 1,
    RefreshToken = 2,
    GuestToken = 3
}

export interface IUserRequest {

    userId?: string;
    sessionId?: string;
    userName?: string;
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    password?: string;
    nickName?: string;
    userRequestType?: UserRequestType;
}

export interface ISessionRequest {
    isGuest: boolean;
    token?: string;
    headerName?: string;
    expiresInSeconds?: number;
    userRequest?: IUserRequest;
    tokenType?: TokenType;
    requestType?: RequestTypes;
}

export interface IProductRequest
{
    id?: number;
    sku?: string;
    displayName?: string;
    productName?: string;
    shortDescription?: string;
    longDescription?: string;
    price?: number;
    stockQuantity?: number;
    isFeatured?: boolean;
    hasOffer?: boolean;
    activeFlag?: boolean;
    categoryId?: number;
    subCategoryId?: number;
    weight?: number;
    packageWeight?: number;
    dimensions?: string;
    color?: string;
    material?: string;
    powerRequirements?: string;
    requestTypes?: RequestTypes;

}

export interface IProductSpecificationRequest
{
    id?: number;
    specName?: string;
    specValue?: string;
    sortOrder?: number;
    productId?: number;
    requestTypes?: RequestTypes;
}

export interface ICheckoutSessionRequest
{
    id?: number;
    isValid?: boolean;
    cartId?: number;
    paymentIntentId?: number;
    finalAmount?: number;
    taxAmount?: number;
    message?: string;
    paymentStatus?: PaymentStatusEnum;
    cartItems?: ICartItemRequest[];
    shippingRate?: IShippingRateRequest;
    shippingAddress?: IAddressRequest;
    billingAddress?: IAddressRequest;
}

export interface  ICartItemRequest
{
    id?: number;
    cartId?: number;
    productName?: string;
    productId?: number;
    quantity?: number;
    unitPrice?: number;
    requestType?: RequestTypes;
}
export interface IValidatedAddressResult
{
    isValid: boolean;
    suggestedAddress?: IAddressRequest;
    errors: string[];
    warnings: string[];
    statusCode: number;
}

export interface IShippingRatesResult
{
    statusCode: number;
    errors: string[];
    shippingRates?: IShippingRateRequest[];
}

export interface IShippingResult
{
    statusCode?: number;
    validatedAddressResult?: IValidatedAddressResult;
    shippingRatesResult?: IShippingRatesResult;
}

export interface IShippingRateRequest
{
    sku?: string;
    carrier?: CarrierTypeEnum;
    serviceName?: string;
    price?: number;
    estimatedDaysInTransit?: number;
    isCheaper?: boolean;
    isFastest?: boolean;
    productName?: string;
    productDefinition?: string;
    warnings?: string[];
    requestType?: RequestTypes;
}

export interface IAddressRequest
{
    id?: number;
    fullName?: string;
    companyName?: string;
    streetAddress?: string;
    streetAddress2?: string;
    city?: string;
    state?: string;
    region?: string;
    postalCode?: string;
    countryCode?: string;
    phoneNumber?: string;
    email?: string;
    requestType?: RequestTypes;
}

export interface IPaymentData
{
    clientSecret?: string;
    checkoutSessionId?: number;
}

export interface ICartRequest {
    id?: number
    cartItems?: ICartItemRequest[]
    requestTypes?: RequestTypes
}

export interface ICartService {
    getCartById(cartId: number): AxiosPromise<ICartRequest>
    addItemToCart(item: ICartItemRequest): AxiosPromise<ICartItemRequest>
    removeItemFromCart(item: ICartItemRequest): AxiosPromise<void>
    updateCartItemQuantity(item: ICartItemRequest): AxiosPromise<void>
}

export interface IProductService
{
    getProductById(productId: number) : AxiosPromise<IProductRequest>;
}

export interface IProductSpecificationService
{
    getProductSpecificationByProductId(productId: number) : AxiosPromise<IProductSpecificationRequest[]>;
}

export interface IAuthService
{
    getGuestToken(): AxiosPromise<ISessionRequest>;
    registerUser(userRequest: IUserRequest): AxiosPromise<string>;
    login(userRequest: IUserRequest): AxiosPromise<ISessionRequest>;
    logout(): AxiosPromise<string>;
}

